(function() {
    'use strict';

    // Full featured selector (with clearing links)
    angular.module( APP_ID )
        .component( 'selectors', {
            bindings: {
                selectablesId:  '@',
                onModelReady:   '&'
            },
            templateUrl:  'app/views/partials/widgets/selectors.html',
            controller:   SelectorsController,
            controllerAs: 'vm'
        });

    // Compact selector (without clearing links)
    angular.module( APP_ID )
        .component( 'selectorsCompact', {
            bindings: {
                selectablesId: '@',
                onModelReady:  '&'
            },
            templateUrl:  'app/views/partials/widgets/selectors-compact.html',
            controller:   SelectorsController,
            controllerAs: 'vm'
        });


    /**
     * Controls switching between set of 1 or 2 selectors based on
     * given @Selectables (~ selectable model).
     *
     * @param {ng.IScope} $scope
     * @param {SelectablesService} SelectablesService
     * @param {LoggerFactory} LoggerFactory
     */
    function SelectorsController(
        $scope,
        SelectablesService,
        LoggerFactory
    ){

        // Helper members.

        /** @type {angular.IController} */
        var vm = this;

        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'SelectorsController' );


        /** @constant */
        var ITEMS = SelectablesService.ITEMS;


        /** Expose to the Scope */
        $scope.ITEMS = ITEMS;

        // Members
        vm.isSecondarySelectorOn    = false;

        // Methods
        vm.savePrimarySelection     = savePrimarySelection;
        vm.clearPrimarySelector     = clearPrimarySelector;

        vm.saveSecondarySelection   = saveSecondarySelection;
        vm.clearSecondarySelector   = clearSecondarySelector;


        // *MUST BE* present to make `ui-select` directive work properly
        vm.selectConfig           = {
            template:       'select2',
            dropdownAutoWidth: true
        }


        /** @constructor */
        vm.$onInit = function() {
            SelectablesService.getSelectablesByIdPromise( vm.selectablesId ).then( function( selectables ) {
                vm.selectablesObject = selectables;
                initSelectors();
                vm.onModelReady({ selectablesModel: vm.selectablesObject.model });
            }).catch(function (err) {
                logger.error(err);
            });
        };


        /** Public methods. */

        function savePrimarySelection() {
            invalidateSelectors();
            SelectablesService.updateSelectableMajors( vm.selectablesId );

            updateUISelect2( 'select2-selector1', ITEMS.PRIMARY );
        }


        function clearPrimarySelector(  ) {
            vm.selectable[ ITEMS.PRIMARY ] = null;
            savePrimarySelection();

            updateUISelect2( 'select2-selector1', ITEMS.PRIMARY );
        }


        function saveSecondarySelection( ) {
            savePrimarySelection();

            updateUISelect2( 'select2-selector2', ITEMS.SECONDARY );
        }


        function clearSecondarySelector( ) {
            vm.selectable[ ITEMS.SECONDARY ] = null;
            savePrimarySelection();

            updateUISelect2( 'select2-selector2', ITEMS.SECONDARY );
        }


        /** Private functions. */

        function invalidateSelectors() {
            // Swap selectors if first is empty and second full.
            if ( !vm.selectable[ ITEMS.PRIMARY ] && vm.selectable[ ITEMS.SECONDARY ] ){
                vm.selectable[ ITEMS.PRIMARY ] = vm.selectable[ ITEMS.SECONDARY ];
                vm.selectable[ ITEMS.SECONDARY ] = null;
            }

            vm.isSecondarySelectorOn = vm.selectable[ ITEMS.PRIMARY ] ? true : false;
        }


        function initSelectors() {

            // Model and states
            vm.selectable       = vm.selectablesObject.model;
            vm.selectorsCount   = vm.selectablesObject.config.selectorsCount;

            // Texts
            $scope._            = vm.selectablesObject._.SELECTOR;
            invalidateSelectors();
        }


        /**
         * Necessary to fix bug where `select2` does not show placeholder.
         *
         * @param {string} selectorsClassName Class name of the selectors to
         * notify
         * @param {string} selectedType One of the types from `ITEMS`
         */
        function updateUISelect2( selectorsClassName, selectedType ) {
            if ( vm.selectable[ selectedType ] ) {
                var primarySelectors =  angular.element( '.' + selectorsClassName );
                angular.forEach( primarySelectors, function( singleSelector ) {
                    singleSelector = angular.element( singleSelector );
                    singleSelector.val( vm.selectable[ selectedType ].$$hashKey ).trigger( 'change.select2' );
                });
            } else {
                angular.element( '.' + selectorsClassName ).val( null ).trigger( 'change.select2' );
            }
        }
    }


    SelectorsController.$inject = [ '$scope', 'SelectablesService', 'LoggerFactory' ];
})();
